<template>
  <div style="height:100%; font-size: 16px; padding-top: 15px; overflow:auto;">
    <b-container fluid>
      <b-row>
        <b-col>
          <ChangePassword :tutorChatToken="tutorChatToken"></ChangePassword>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ChangePassword from "../components/Main/ChangePassword";

export default {
  components: {
    ChangePassword
  },
  data() {
    return {
      tutorChatToken: ""
    };
  },
  created() {
    document.title = "修改密碼";
    this.tutorChatToken = this.$route.query.tct;
  },
  methods: {}
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/MobileChangePasswordView.vue